import { format, isThisWeek, isToday, isTomorrow, parseISO } from 'date-fns';

/**
 * Compact relative framing for the badge's inline pin context. Produces strings
 * like "today 2pm", "tomorrow 9am", "Tue 5/6" — designed to read as a casual
 * append after a verb ("Collect $30 · tomorrow 2pm").
 *
 * Returns null for invalid input or when no pin is set.
 */
export function humanizePinnedAt(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const parsed = parseISO(iso);
  if (Number.isNaN(parsed.getTime())) return null;

  // Lowercase a/p marker, drop ":00" minutes for round hours.
  const time = format(parsed, 'h:mma').toLowerCase().replace(':00', '');

  if (isToday(parsed)) return `today ${time}`;
  if (isTomorrow(parsed)) return `tomorrow ${time}`;
  if (isThisWeek(parsed)) return `${format(parsed, 'EEE')} ${time}`;
  return `${format(parsed, 'EEE M/d')} ${time}`;
}
